/**
 * THE NAME FOR WHAT THE PROCESS IS WAITING ON THE OWNER FOR — one home, three surfaces.
 *
 * WHY THIS FILE EXISTS (P138 `R-P2.9` / `T1418` / `T1419`). The label was `Gaps`, in three places, and
 * `Gaps` is a **LIVE `W11` breach**: `persona_FTUE-NewUser.md` W11 is *"NEVER MAKE ME FEEL LIKE A
 * PROBLEM"*, and `RULES_NAMING` §6's POSITIVITY gate forbids a name that makes the reader feel
 * deficient. `gaps` also **failed ANNOUNCEMENT** (gate 2): a reader cannot tell from the word whether
 * anything is expected of him, and *a name you must open to understand has failed*.
 *
 * SO THE REPLACEMENT HAD TO PASS BOTH GATES, and the second one is the easy one to miss:
 *
 *   POSITIVITY   — a **question** asks for his expertise. It does not call him deficient, and it is not
 *                  a hole in the product; it is the product correctly saying what it needs. (`Details`
 *                  passed this gate and was still rejected — see `RULES_NAMING` §6's origin note — which
 *                  is why a rename that merely sounds pleasant is not enough.)
 *   ANNOUNCEMENT — **"for you"** says, from the label and before opening anything, that HIS action is
 *                  what the surface is waiting on. `Gaps (3)` said three of something were wrong;
 *                  `Questions for you (3)` says three things need him. That is the whole difference
 *                  `W11` and gate 2 are about.
 *
 * IT MATCHES THE PILLAR'S OWN WORDS. `R-P2.9` calls this surface *"the questions-we-cannot-answer
 * surface"*, so the label introduces no new vocabulary — it uses the one the requirement already had.
 *
 * THE KEYS ARE NOT RENAMED, DELIBERATELY. The API field `gaps`, the state `showGaps` and the filter id
 * `"gaps"` stay: `RULES_NAMING` §3 governs **names a person reads**, and an acronym-or-key note in §10
 * says so explicitly (*"a gate about names does not govern keys"*). Renaming the wire contract would be
 * a breaking change to satisfy a rule that is not about it — and the surface is where the breach was.
 */

/** The label, in the sentence case a tab, a toggle and a heading all read correctly. */
export const WAITING_ON_OWNER = "Questions for you";

/**
 * The same fact with a count, pluralised.
 *
 * `1 question for you` / `3 questions for you` — a label that reads `1 questions` teaches the reader
 * that the surface was not read by whoever wrote it.
 */
export function waitingCount(count: number): string {
  const n = Number.isFinite(count) ? Math.max(0, Math.trunc(count)) : 0;
  return `${n} question${n === 1 ? "" : "s"} for you`;
}
